<template>
  <div class="termsWrap">
    <div class="content" v-html="text" />
  </div>
</template>

<script>
export default {
  name: "userterm",
  data() {
    return {
      text: `
<h3>《小库注册用户协议》</h3>
<pre>
小库（以下简称为“本平台”）注册用户协议（以下简称为“本协议”）是由用户（以下简称为“您”）与深圳小库科技有限公司（以下简称为“小库公司”或“我们”）就小库公司提供的产品和服务所订立的协议。

您在接受小库公司的服务之前，请务必仔细阅读本协议，小库公司根据本协议的条款及不时发布的规则为您提供本平台的服务。本协议的条款可由小库公司随时修改，修改后的用户协议在网站上一经公布即有效代替原来的用户协议。<b>其中，免除或限制责任条款等重要内容会以加粗形式提示您注意，您应重点阅读。一旦您使用小库产品网站或服务，则视为您已充分理解本条款并承诺遵守本条款，接受本条款的约束。</b>
<b>请您确认，如果您未满18周岁，请在监护人陪同下阅读、同意接受本协议，并申请开通相关功能。但如您未满14周岁，应该立即停止申请使用本服务。</b>
一、服务说明
本平台在您使用服务期间，为您提供包括但不限于如下服务：1、体验项目测试样例（包含基地评估、智能规划、智能单体和彩总智图等）；2、申请个人、企业/组织账号或试用账号。小库公司为您具体提供的本平台服务以最终开放的功能权限为准。除非本协议另有其它明示规定，本平台增加或强化目前的任何新功能，包括所推出的新产品，均受本使用协议之规范。
<b>您了解并同意，本平台之服务、产品与资料仅依其当前所呈现的状况提供，而且本平台明确地表示拒绝对于“服务”、“资料”或“产品”等给予任何明示或暗示之担保或保证，本平台对于因“服务”、“产品”或“资料”等所产生之任何直接、间接、附带或因此而导致的衍生性损失概不负责。</b>

<b>二、账号管理</b>
1、账号注册及开通
1.1 为了使用小库产品网站和服务，您必须依照小库产品网站的要求注册一个用户账号（“<b>账号</b>”）。您有权选择合法的字符组合作为您的账号，并自行设置符合安全要求的密码。用户设置的账号、密码是用户用以登录并以注册用户身份使用小库产品网站及服务的凭证。
1.2 <b>您所设置的账号不得违反相关法律、法规、条例或规章（统称“法律”）及小库产品网站相关规则，您的账号名称、头像和简介等注册信息及其他用户信息中不得出现违法或不良信息，未经他人许可不得以他人名义（包括但不限于冒用他人姓名、名称、字号、头像、商标、商业标识等足以造成混淆的方式）开设账号，不得在小库产品网站恶意注册账号。您在账号注册过程中需遵守相关法律，不得实施任何侵害国家利益、公共利益，损害其他自然人、法人和非法人组织合法权益，有害社会道德风尚的行为。我们有权对您提交的注册信息进行审核，如发现用户账号注册信息存在违法、不良信息、恶意注册或其他违规情形的，我们有权视实际情况不经通知采取暂停使用、冻结账号、注销账号、不予注册、收回账号、暂停或终止提供服务等措施。</b>
1.3 <b>您承诺以合法身份信息开通本平台下账号。您应当按照小库产品网站注册流程填写、提交真实、合法、有效的资料和信息（统称“资料”）。 </b>
1.4 <b>依照相关法律的规定，为使用小库产品网站及服务，您需要注意并及时更新上述相关信息。若您提交的资料不准确、不规范、不合法或者我们有理由怀疑其中包含前述内容，我们有权不予注册相关账号、拒绝为您提供相关服务或限制、冻结、注销或收回相关账号，由此产生的损失由您自行承担。</b>
1.5 为保护账号和交易安全，我们可能会要求您提供更多的身份资料和信息，做进一步的身份或资格认证，您的账户只有在通过这些认证和验证之后，方可获得访问小库产品网站和使用服务的资格。您特此授权我们可以自行或通过第三方验证机构验证您的身份信息和资格，并取得您的相关资料。
1.6 您也可以选择通过授权小库产品网站使用您合法拥有的且小库产品网站支持的第三方账号信息，按照小库产品网站注册页面的提示完成注册及登录流程，并获得账号，但第三方账号对此有限制或禁止的除外。
2、账号的使用安全
2.1 您的账号是您在小库产品网站进行一切活动的唯一标识。您有责任依本平台注册提示填写您正确的注册邮箱、密码、账号、手机号码等信息，并确保今后更新的登录邮箱、名号、头像及手机号码等资料的有效性、合法性和保密性，并对您以注册账号名义所从事的活动承担全部法律责任，包括但不限于您通过小库产品网站进行的任何数据修改、言论发表、款项支付等行为。您应高度重视对账号与密码的保密，在任何情况下不向他人透露账号及密码。我们在任何时候均不会主动要求您提供您的账号（但您要求我们通过您的账号排查或解决问题时除外）及密码。若您发现他人未经许可使用您的账号或发生其他任何安全漏洞或事件，应立即通知我们，我们将协助您冻结账号、更改密码或进行其他安全设置。<b>您理解并接受我们对您的请求采取行动需要一定时间，我们对在采取行动前您的任何损失或已产生的其他后果不承担任何责任。</b>若您提供任何违法、不道德或小库公司认为不适合的资料，或者小库公司有理由怀疑行为属于程序或恶意操作，小库公司有权无须事先通知即可暂停或终止您的账号之使用，并拒绝您于现在和未来使用本平台之任何部分。
2.2 <b>您的账号仅限于您本人使用，未经我们书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用。如果我们发现或有合理理由认为使用者并非账号注册人，为保障账号安全，我们有权立即暂停或终止向该注册账号提供服务，或注销该账号。您同意： 
（1）账号遭到未获授权的使用，或者发生其它任何安全问题时，立即通知小库公司； 
（2）如果未保管好自己的账号等信息，因此而产生的任何损失或损害，小库公司不承担任何责任；
（3）您对使用账号的所有行为给您自身、小库公司或第三方造成的损害承担全部责任，包括未保管好自己的账号或其他信息的情形。</b>
2.3 若企业/组织因自身经营需要，将其以企业/组织名义进行注册的账号交由个人管理的，应做好权限管控，并且在管理人员变动时完成内部交接和密码变更以保证企业/组织账号安全。
2.4 您的账号在丢失或遗忘密码后，可遵照我们提供的密码找回途径请求找回密码。如找回失败，您可以通过发送邮件至“mo@xkool.org”或拨打热线 “400 807 1991”联系我们协助找回账号或密码。我们的密码找回机制仅识别申诉单上所填资料与系统记录资料是否具有一致性，而无法识别申诉人是否是真正的账号有权使用者。我们特别提醒您应妥善保管您的账号和密码。当您使用完毕后，应安全退出。<b>因他人恶意攻击或您的安全保障不当或不足够等自身原因（用户自身原因包括但不限于随意向第三方透露账号和密码及所有注册资料、多人共享同一个账号、安装非法或来路不明的程序、将已经登陆账号的设备提供给他人使用等）或其他不可抗力而导致的盗号或密码丢失，我们不承担任何责任。</b>
3、账号冻结
您的账号（全部或部分权限或功能）在如下情况可能被冻结（如账号被限制资金转出功能等），我们可视情况通过邮件、站内信、短信或电话等其一种或多种方式通知您：
(1) 基于小库产品网站或服务运行和交易安全的需要；
(2) 您违反本条款或您所使用的服务所适用的相关协议；
(3) 您违反国家法律法规和相关规定；
(4) 您遭到他人投诉，且对方已提供相关证据，而您未按照要求及时提供适当的相反证据；
(5) 我们根据合理分析判断您的账号操作等存在异常；
(6) 国家权力机关（包括但不限于法院、检察机关、公安机关、政府等）要求进行的冻结；
(7) 账号归属存在争议；
(8) 经我们合理判断，您的账号发生了与如上行为性质相同或产生如上类似风险的其他情况；或
(9) 本条款规定的其他情况。
4、账号注销
4.1 当您决定不再使用您的账号时，您可以通过发送邮件至“mo@xkool.org”或拨打热线 “400 807 1991”联系我们进行账号注销，但须注意：
(1) 您仅能申请注销您本人的账号，并应依照小库产品网站流程进行注销；
(2) 您仍应对您在注销账号前该账号下相关操作行为承担相应责任；
(3) 注销成功后，该账号记录、功能等将无法恢复或提供。
4.2 <b>若您违反法律法规规定或违反本条款的相关规定，我们有权注销您的账号，并清空您所上传和存储（合称为“存储”）在小库产品网站及服务中的数据，由此导致的数据损失将由您自行承担。</b>
4.3 <b>如您连续12个月未通过您的账号登录小库产品网站，且您的账号下不存在任何可用服务，我们有权自主决定注销您的账号。</b>
5、账号申诉
5.1 在发生账号冻结或注销情形下，您可通过发送邮件至“mo@xkool.org”或拨打热线 “400 807 1991”联系我们申请解除冻结或注销。但为了您的账号安全，您应按要求提供相关信息或文件（包括但不限于相关身份证明文件），以便我们进行核实。<b>您应充分理解您的申诉并不必然通过，我们有权根据小库产品网站相关规则决定是否同意您的申诉请求。</b>
5.2 <b>您理解并同意，如果您拒绝如实提供身份证明及相关资料（包括我们要求您提供的补充资料），或提供的申诉资料未能通过我们的审核，我们有权长期冻结该等账号且长期限制账号部分或全部功能。</b>
<b>三、小库产品网站和服务的使用</b>
1、您使用小库产品网站及服务需自行准备与服务有关的终端设备（如电脑、手机、存储设备、网络设备等装置），一旦您通过该等终端设备登录并访问小库产品网站，即视为您使用了小库产品网站及相关服务。
2、除本条款外，如果您所使用的服务适用本协议及配套协议条款条件的，您对该服务的使用同时应受该等适用的本协议及配套协议的约束。
3、若您通过小库产品网站和服务从事网站运营、应用/软件/服务运营等业务活动，您应依据法律要求取得相应经营资质。<b>我们有权依据您订阅的服务类别，要求您提供该等服务相关运营资质的书面证明进行审核。如您未能及时提供所需资质证明，我们有权不予注册相关账号，或限制、冻结、注销或收回相关账号，由此产生的损失由您自行承担。</b>
4、<b>为了完善服务，保证小库产品网站运行的安全性和稳定性，我们会不定期对小库产品网站及相关设备、系统、软件等进行检修、维护、升级或优化，前述常规维护可能造成小库产品网站或服务在合理时间内中断或暂停。我们将至少提前24小时，就计划内的常规维护事宜通知您。若发生因不可抗力、基础运营商过错等原因导致的非常规维护，我们将在该等事件发生后及时通知您。此外，为前述目的，我们可能进行包括机房迁移、设备更换等服务环境调整，前述情况可能导致小库产品网站或服务在合理时间内中断或暂停，对此我们将至少提前30天通知您。</b>
5、<b>您应正确配置和使用小库产品网站和服务，并自行采取适当的安全措施对您存储到小库产品网站和服务中，或通过小库产品网站和服务收集、存储、使用、加工、传输、提供、分析、转让、分发、公开和/或删除（统称“处理”）的数据（“用户数据”）进行保护和备份。您声明并保证您接入小库产品网站及服务的算法、模型、数据、产品、服务的安全性、稳定性、有效性，不会对我们和/或我们的关联方的相关系统造成损害，亦不会对我们和/或我们的关联方或其他第三方数据造成损害。由于用户数据引起的安全漏洞，或由于您未按照本条款要求使用小库产品网站或服务而引起的安全漏洞，其相关后果由您自行承担责任。</b>
6、小库产品网站和服务中可能包括或链接至第三方提供的信息、产品、代码、软件和/或其他服务（包括网站，统称“<b>第三方产品</b>”）。如果您通过小库产品网站或服务获取或使用第三方产品，应自行评估该等第三方产品是否符合您的要求，并根据自身情况决定是否接受第三方产品适用的协议和规则。<b>我们特别提醒您，本条款以及其他与小库产品网站及服务相关的协议和规则均不适用于任何第三方产品，您因使用第三方产品产生的纠纷应由您与相关第三方自行解决。</b>
7、在某些情况下，为了帮助您更便捷的使用小库产品网站及服务，我们可能会展示相关参考代码或软件（如属于第三方开源软件，您应遵守第三方开源软件的相关使用要求），基于相应展示页面的使用说明，该等代码或软件可能允许您予以下载、进行二次开发等相关操作；您确认并承诺，该等代码或软件的知识产权属于我们，您在使用时应明确标明权利人；同时，我们不对您能否使用该等代码、软件，以及您使用该等代码、软件的工作和后果负责。
<b>四、禁止性行为和违法内容
1、您访问或使用小库产品网站，或允许他人访问或使用小库产品网站时不得具有下列行为，也不得为其提供便利：
（1）在本协议规定的条款之外，使用、复制、修改或转让本平台或其中的任一部分或以任何形式授权给第三方使用、销售、转让、发行、出租、翻译本平台系统。
（2）未经小库公司允许，将账号转让、出售或出借给他人使用。
（3）对本平台进行反向工程、反向编译或反汇编；试图进行任何获得本平台系统原代码的访问或行为；或在竞品中侵犯小库的正当权利。
（4）有对本平台的连续服务或商誉构成损害的行为，包括但不限于恶意散布针对本平台、“小库”的负面信息、攻击本平台服务器等。
（5）未经小库许可擅自去除版权标识（在本平台的所有副本上包含所有的版权标识）。
（6）未经官方渠道通告小库公司的情况下直接和小库公司工程师或产品人员接触。
 (7) 利用技术或其他手段，对小库产品网站或服务的正常运行施加不利影响，包括但不限于：
a. 使用未经我们授权或许可的任何插件、外挂、系统或第三方工具对小库产品网站及服务进行破坏、修改或施加其他影响，包括但不限于大量占用小库系统或者网络带宽资源，给小库引擎系统或者使用小库产品网站或服务的其他用户的网络、服务器、产品或应用带来严重负荷，影响系统通畅；
b. 违反与我们的网络相联通之网络、设备或服务的操作规定，对小库产品网站或服务实施未经授权之接取、盗用、干扰或监测；
c. 实施任何改变或试图改变小库产品网站或服务提供的系统配置或破坏系统安全的行为；
d. 复制、模仿、修改、翻译、改编、出借、出售、转许可、在网络上传播、发布或转让服务，或对小库产品网站或服务进行反向工程、反向汇编、编译或者以其他方式破坏、破译、尝试发现源代码；或
e. 恶意注册账号，包括但不限于频繁、批量注册账号。
（8）为下述任一目的访问小库产品网站或服务：
a. 建立具有竞争力的产品或服务；
b. 复制服务的任何特征、功能或图形；
c. 执行或披露服务的任何基准测试、安全测试或性能测试。
（9）利用或针对小库产品网站或服务进行任何危害网络安全（含小库产品网站安全）、或破坏互联网秩序的行为，包括但不限于：
a. 非法侵入他人网络、干扰他人网络正常功能、窃取网络数据等活动；
b. 制作、发布或传播用于从事侵入网络、干扰网络正常功能或防护措施、窃取网络数据等危害网络安全活动的程序、工具；
c. 明知他人从事危害网络安全的活动的，为其提供技术支持、广告推广、支付结算等帮助；
d. 使用未经许可的数据或进入未经许可的服务器/账号；
e. 未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加、存储信息；
f. 未经许可，企图探查、扫描、测试小库产品网站系统或网络的弱点；
g. 发送、上传、储存或传播带有病毒的、蠕虫的、木马或其他有害的计算机代码、文件、脚本或程序（“程序”），符合中国互联网协会所公布的恶意软件特征的程序，或类似的旨在对任何计算机软硬件的操作或安全产生不利影响的程序（统称“有害程序”）或其他破坏干扰正常网络信息服务的行为；
h. 伪造TCP/IP数据包名称或部分名称。
（10）违反法律法规、本条款、小库产品网站其他规则或侵犯他人合法权益的行为，如：
a. 实施诈欺、虚假不实或误导行为，或实施侵害他人知识产权等任何合法权益的行为，如“私服”、“外挂”等，删除、隐匿、改变他人的所有权利管理电子信息及所有权声明，或故意避开或破坏他人为保护知识产权而采取的技术措施；或
b. 因从事包括但不限于“DNS解析”、“安全服务”、“域名代理”、“反向代理”等任何业务，导致您自己频繁遭受攻击（包括但不限于 DDoS 攻击）且未及时更正行为，或未根据我们要求消除影响，从而对我们或他人产生影响的。
（11）未经适当授权访问小库产品网站或小库产品网站的任何部分，或企图进行上述行为；或
（12）其他有害或不当的行为。
2、您应确保您使用小库产品网站及服务开发、制作、利用、上传、评论、发布、传播、存储、分享（统称“制作”）的内容（包括但不限于上传至小库产品网站的未公开分享的内容）不违反本条款且符合相关法律，并应对其合法性、准确性、完整性和可靠性负责。您不得利用小库产品网站或服务制作下列信息：
(1) 反对宪法确定的基本原则的；
(2) 危害国家安全，泄露国家秘密的，颠覆国家政权，破坏国家统一的；
(3) 损害国家荣誉和利益的；
(4) 歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；
(5) 宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；
(6) 煽动民族仇恨、民族歧视，破坏民族团结的；
(7) 煽动地域歧视、地域仇恨的；
(8) 破坏国家宗教政策，宣扬邪教和迷信的；
(9) 编造、散布谣言、虚假信息，扰乱经济秩序和社会秩序、破坏社会稳定的；
(10)散布、传播淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
(11)危害网络安全、利用网络从事危害国家安全、荣誉和利益的；
(12)侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；
(13)对他人进行暴力恐吓、威胁，实施人肉搜索的；
(14)散布污言秽语，损害社会公序良俗的；
(15)侵犯他人隐私权、名誉权、肖像权、知识产权等合法权益内容的；
(16)过度营销信息或垃圾信息；
(17)侵害未成年人合法权益或损害未成年人身心健康的；或
(18)其他违反法律、公共政策、社会治安或公序良俗、干扰小库产品网站正常运营或侵犯其他用户或第三方合法权益内容的其他信息。
五、隐私及用户信息的保护
我们非常重视用户信息的保护，并且将勤勉和审慎地保护用户信息安全，具体请查询《小库用户隐私协议》。
六、违规处理
1、针对您违反本协议的行为，我们有权展开调查，并视情况采取警示、立即停止传输信息、删除内容、限制账号部分或者全部功能、冻结账号直至永久关闭账号等措施，或采取进一步法律行动。我们有权公告处理结果，且有权根据实际情况决定是否恢复账号使用。对涉嫌违反法律、涉嫌违法犯罪的行为，我们将有权保存有关记录，并依法向有关主管部门报告、配合有关主管部门调查。对已删除内容，我们有权不予返还。
2、我们尊重并保护法人、公民的知识产权、名誉权、姓名权、隐私权等合法权益。因您的违法或违规行为导致我们或我们的关联公司向任何第三方承担赔偿责任或遭受相关处罚的，您应足额赔偿相关主体因此遭受的全部损失。
七、国际使用之特别告知
您已了解互联网的无国界性，同意遵守当地所有关于网上行为及内容之法律法规。您特别同意遵守有关从中国或所在国家或地区输出信息之传输的所有适用法律法规。
八、知识产权
1、未明示授予的一切权利均为小库公司所有，您获得的只是本平台产品的使用权。本平台产品的版权归小库公司所有，受到著作权法及其他知识产权法及条约的保护。未经小库公司许可，任何人不得擅自使用（包括但不限于通过任何机器人、蜘蛛等程序或设备监视、复制、转载、散布、传播、播放、展示、出售、许可、镜像、上载、下载本小库产品网站及相关服务中的内容）。
您使用期间，通过本平台输出的成果如果是通过向小库付费后获得的，输出成果的知识产权属于您，您可以将其商业化使用；但在您完成相关成果的付费之前，本平台产生输出成果的知识产权属于小库，不能用于其他商业目的。
2、为提升用户使用服务的体验，我们可能会将您在小库上传的内容（包括但不限于图片、模型、解决方案等）进行分析或作为AI训练使用，您同意上传的数据或文件并不改变该数据或文件的所有权，并表明您同意授予小库公司及关联方在全球范围内免费、不可撤销的、永久的、可再许可或转让的非独家使用权许可，小库公司及关联方有权根据该授权访问、使用匿名化处理后的上传内容，由此产生的新作品（不包含您在小库上传的内容）知识产权将归于小库公司。上传前，您应当确认您拥有该等内容的所有权及知识产权，或已经取得合法授权。
同时，我们还特别提示您确认您所发布的内容不会侵犯他人的商业秘密或其他合法权利，也不会违背您对第三方负有的保密义务。
3、未经我们书面同意，您不能单独或/和结合其它方式展示或使用我们或我们的关联公司所拥有的商标、服务标记、商号、字号、域名、网站名称或其他任何显著品牌特征（统称“标识”），也不能将我们或我们的关联公司作为您的案例、合作对象等在您的网站、客户端、应用程序等，或新闻媒体、资本市场等公开场合披露。
4、您理解并同意授权我们可以在销售、营销等宣传、推广材料和活动中使用您的名称、商标、标识，但仅限于表明您是我们的客户或合作伙伴。
九、免责声明
1、您理解并同意，在使用小库产品网站和服务的过程中可能会遇到以下情况使服务发生中断。我们将及时配合相关部门积极解决。但由此给您造成的损失，我们将予以免责：</b>
(1) 不可抗力事件，包括但不限于自然灾害、政府行为、法律的颁布或调整、罢工（任何一方内部劳资纠纷除外）、动乱等不能预见、不能避免并不能克服的客观情况；
(2) 基础运营商原因，包括但不限于电信部门技术调整、电信/电力线路被他人破坏、电信/电力运营商对电信网络/电力资源进行安装、改造、维护；
(3) 网络安全事故，如计算机病毒、木马或其他恶意程序、黑客攻击的破坏；
(4) 您通过本协议或相关服务所适用的协议所约定之外的方式使用小库产品网站或服务；
(5) 您操作不当或您的计算机软件、系统、硬件、通信线路或其他第三方资源出现故障；
(6) 其他不可归因于我们的过错、或我们无法控制或合理预见的情形。
<b>2、您理解并同意，小库产品网站及服务是按照现有技术和条件所能达到的现状提供的，我们无法保证小库产品网站和服务毫无瑕疵。我们会尽最大商业努力确保小库产品网站和服务的连贯性和安全性，同时请您理解并同意，我们不就任何由第三方产品所引起的问题负责，也不就下述事项进行任何明示或暗示的保证：</b>
(1) 小库产品网站及服务是连续不中断、即时、安全或不存在错误的；
(2) 您对小库产品网站及服务的使用能充分满足您的要求和使用目的；
(3) 我们将会或有能力修正小库产品网站的所有缺陷或错误；
(4) 小库产品网站的服务将与您的内容或我们未提供的任何其他硬件、软件、系统、服务或数据兼容；
(5) 小库产品网站和服务不会受到恶意程序、黑客攻击的破坏；及
(6) 其他我们无法控制或合理预见的情形。
3、小库产品网站上转载的内容均出于传递更多信息之目的，并不意味我们赞同其观点或证实其内容的真实性。小库产品网站上还可能存在指向第三方网站的链接，我们提供这些链接仅为访问提供便利，并不表示我们对这些信息的认可或推荐。我们并不保证这些链接所指向的信息、数据或建议是准确、完整或可靠的。
4、<b>小库公司不就因使用或不能使用本平台而发生的损失，包括但不限于营业利润损失、业务中断、业务信息、文档、数据丢失或其他经济损失承担赔偿责任，即使已通知小库公司有可能发生该等损失的，亦是如此。</b>
十、保密
保密信息指不为公众所知，又能为其所有者带来经济效益的所有信息、数据或技术，包括但不限于提供方的与研究、开发、生产、产品、服务、客户、市场有关的平台、程序、发明、工艺、设计、图纸、专有技术、工程、流程、方式、硬件配置信息、客户名单、合同、价格、成本、研究报告、预测和估计、报表、商业计划、商业秘密、商业模式、公司决议等任何或所有的商业信息、财务信息、技术资料、生产资料以及会议资料和文件；保密信息既包括书面认定为保密或专有的，又包括口头给予，随即被书面确认为保密或专有的。
未经小库公司书面同意或公开保密信息，您不得向第三方披露保密信息。
本平台及文档保密信息仅是为了您使用平台，根据本协议的规定所提供之保密信息的使用，应只限于该等目的，除非在披露该等保密信息时，小库公司另外以书面形式指明其他目的。
<b>十一、通知与送达</b>
1、您应向我们提供真实有效的联系方式。联系方式变更的，请您务必及时向我们更新。若因您的联系信息存在虚假、无效、未及时更新等情形致使您无法及时获取业务通知、客户服务、投诉处理、纠纷协调、技术支持等情况的，将由您自行承担相应后果和责任。
2、我们将通过小库产品网站的网页公告、系统通知、站内信、电子邮件、手机短信、即时通讯工具、邮政函件或快递等方式中的一种或多种方式向您发送与小库产品网站和服务有关的业务通知、服务提示、验证消息、营销信息等各种信息（包括但不限于更新后的服务规则、服务升级、机房裁撤、迁移、广告等）。您通过任何形式提供给我们的联系地址、电话、电子邮件或/和其他联系方式，均被视为有效送达的联系方式。此类通知将对您的权利义务产生重大影响，请您务必及时关注。前述信息在以下情况下视为已送达：
(1) 以网页公告等形式公布的，一经公布即生效（另有说明除外）；
(2) 以电子形式（包括系统通知、站内信、电子邮件、手机短信、即时通讯工具等）发送的，在发送成功后视为已送达；
(3) 以纸质载体发出的，以交邮后的第三（3）个自然日视为已送达。
3、我们可能会向您在使用小库产品网站及服务的过程中提供的您的联系方式发送通知，用于用户消息告知、身份验证、安全验证、用户使用体验调研等用途。此外，我们也可能会通过在前述联系方式与您分享您可能感兴趣的服务、功能或活动等商业性信息，如不愿接受这些信息，您可以通过手机短信中提供的退订方式进行退订，也可以直接与我们联系进行退订。
4、如您对本协议内容或小库产品网站或服务的使用有任何疑问、意见或建议，或者认为小库产品网站或服务的内容可能侵犯您的合法权益，您可发送邮件至“mo@xkool.org”或拨打热线 “400 807 1991”联系我们。
<b>十二、其他</b>
1、小库公司保留对本协议的最终解释权。
<b>2、本协议的成立、生效、履行、解释及争议的解决均应适用中华人民共和国大陆地区法律。如您与小库公司就本协议内容或其执行发生任何争议，双方应进行友好协商；协商不成时，任何一方均可向小库公司所在地有管辖权的人民法院提起诉讼。</b>
3、我们可能会依据国家政策、技术条件、产品功能等变化需要而不时更新本条款，我们会将更新后的条款予以发布，并以适当方式（网站公布和/或系统通知等）提醒您更新后的内容。
<b>至此，您确认已经详细阅读并已理解本协议，并同意严格遵守各条款和条件。</b>
</pre>`,
    };
  },
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
